import { ClientNotification } from '../../notification/client-notification';
import { RpcBaseData } from '../rpc-base';

/**
 * RPC notification request name and version.
 */
export class RpcNotificationKey {
    public static command = 'Notification';
    public static version = '0.1.0';
}

/**
 * Rpc notification record data.
 */
export interface RpcNotification extends RpcBaseData, ClientNotification {
    /**
     * node name.
     */
    nodeName: string;

    /**
     * The timestamp. Date.now() / the number of milliseconds elapsed since 1 January 1970 00:00:00 UTC.
     */
    timestamp: number;
}
